export const GET_BLOGS = 'app/get_blogs'
export const GET_ARTICLE_BY_ID = 'app/get_article'
export const BLOGS_PER_PAGE = 4
